import { Base, createApp } from '@studiometa/js-toolkit';
import type { BaseConfig, BaseProps } from '@studiometa/js-toolkit';
import { ScrollReveal, LargeText } from '@studiometa/ui';
import RelativeCursor from './components/RelativeCursor.js';
import ScrollAnimationParent from './components/ScrollAnimation/ScrollAnimationParent.js';
import ScrollAnimation from './components/ScrollAnimation/ScrollAnimation.js';
import SplitLines from './components/SplitLines.js';
import CanvasSphere from './components/CanvasSphere.js';
import Slider from './components/Slider/Slider.js';
import Footer from './components/Footer.js';
import Figure from './components/Figure.js';

export interface AppProps extends BaseProps {
  $el: HTMLBodyElement;
  $refs: {
    showreelOrigin: HTMLElement;
    bg: HTMLElement;
  };
  $children: {
    RelativeCursor: RelativeCursor[];
    Figure: Figure[];
    LargeText: LargeText[];
    ScrollReveal: ScrollReveal[];
    ScrollAnimationParent: ScrollAnimationParent[];
    ScrollAnimation: ScrollAnimation[];
    SplitLines: SplitLines[];
    Slider: Slider[];
    CanvasSphere: CanvasSphere[];
    Footer: Footer[];
  };
}

/**
 * App class.
 */
class App extends Base<AppProps> {
  /**
   * Config.
   */
  static config: BaseConfig = {
    name: 'App',
    refs: ['showreelOrigin'],
    components: {
      RelativeCursor,
      Figure,
      LargeText,
      ScrollReveal,
      ScrollAnimationParent,
      ScrollAnimation,
      SplitLines,
      Slider,
      CanvasSphere,
      Footer,
    },
  };
}

export default createApp(App);
